export const camelToScreamingSnake = camel => {
  const result = camel.replace(/([A-Z])/g, ' $1');
  return result.split(' ').join('_').toUpperCase();
};